import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';

import { changeScrollBehavior } from 'src/common/helpers';
import { Button, Drawer } from 'src/components/core';
import { Cross } from 'src/components/core/icons';
import { FlexContainer } from 'src/components/core/layout/FlexContainer';
import { useAppSelector } from 'src/hooks';

import { Form } from './form';

const StyledDrawer = styled(Drawer)`
    ${({ theme: { colors } }) => `
        .content-wrapper{
            background: ${colors.background.primary};
            border-radius: 8px 8px 0px 0px;
            display: block;
            .drawer-head{
                padding: 17px 17px;
                justify-content: space-between;
                .close-action{
                    cursor: pointer;
                    height: 16px;
                    width: 16px;
                    viewBox: 0 0 16px 16px;
                }
            }
        }
    `}
`;

const MobileFormContainer: FC = () => {
    const { t } = useTranslation();
    const { colors } = useTheme();
    const [isOpen, setIsOpen] = useState(false);
    const { orderCreated } = useAppSelector((state) => state.spotPage);
    const toggleDrawer = () => {
        setIsOpen(!isOpen);
        changeScrollBehavior(!isOpen);
    };

    //close drawer when order is created
    useEffect(() => {
        setIsOpen(false);
    }, [orderCreated]);

    return (
        <>
            {isOpen && (
                <StyledDrawer handleClose={toggleDrawer} anchor="bottom" open={isOpen}>
                    <FlexContainer className="content-wrapper">
                        <FlexContainer className="drawer-head">
                            {t('place_order')}
                            <span></span>
                            <Cross
                                className="close-action"
                                fill={colors.text.tertiary}
                                onClick={toggleDrawer}
                            />
                        </FlexContainer>
                        <Form />
                    </FlexContainer>
                </StyledDrawer>
            )}
            {!isOpen && (
                <FlexContainer
                    styles={{
                        position: 'fixed',
                        bottom: 0,
                        width: '100%',
                        padding: 16,
                        background: colors.background.primary,
                        zIndex: 1,
                    }}
                >
                    <Button
                        styles={{ marginRight: '7.5px', color: `${colors.brand.main} !important` }}
                        fullWidth
                        className="bg-up"
                        onClick={toggleDrawer}
                    >
                        {t('buy')}
                    </Button>
                    <Button
                        styles={{ color: `${colors.brand.main} !important`, marginLeft: '7.5px' }}
                        fullWidth
                        className="bg-down"
                        onClick={toggleDrawer}
                    >
                        {t('sell')}
                    </Button>
                </FlexContainer>
            )}
        </>
    );
};

export { MobileFormContainer };
